import React from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import farmTheme from './farmTheme';
import adminTheme from './adminTheme';

const DynamicThemeProvider = ({ children }) => {
  const location = useLocation();
  
  // Check if current path is an admin route
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  // Select theme based on route
  const currentTheme = isAdminRoute ? adminTheme : farmTheme;
  
  return (
    <ThemeProvider theme={currentTheme}>
      {children}
    </ThemeProvider>
  );
};

export default DynamicThemeProvider;